import { type CLOCK_CADENCE, useWallClockEffect } from "@/providers/wall-clock";
import { useDataViewerStore } from "../data-viewer-provider";

// Mounted only when auto-refresh is on — hooks can't be called conditionally.
export function AutoRefreshTicker({ cadence }: { cadence: CLOCK_CADENCE }) {
    const advanceWindowToNow = useDataViewerStore((state) => state.advanceWindowToNow);
    useWallClockEffect(cadence, advanceWindowToNow, { runOnMount: false });
    return null;
}
